'use client';
import React from 'react';
import { CATEGORIES, CategoryName } from '@/lib/worksheetData';
import { useWorksheetStore } from './worksheetStore';

const ALL_OPTION = { id: 'filter-all', name: 'All' as const };

export default function CategoryFilterBar() {
  const { selectedCategory, setSelectedCategory } = useWorksheetStore();

  const options = [ALL_OPTION, ...CATEGORIES.map((c) => ({ id: `filter-${c.id}`, name: c.name }))];

  return (
    <div className="flex flex-wrap gap-2" role="group" aria-label="Filter by category">
      {options.map((opt) => {
        const isActive = selectedCategory === opt.name;
        return (
          <button
            key={opt.id}
            onClick={() => setSelectedCategory(opt.name as CategoryName | 'All')}
            className={`px-3 py-1.5 rounded-full text-sm font-medium transition-all duration-150 scale-press ${
              isActive
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'bg-card border border-border text-muted-foreground hover:border-primary hover:text-primary'
            }`}
          >
            {opt.name}
          </button>
        );
      })}
    </div>
  );
}